import { useTranslation } from 'react-i18next'

import ProductProperties from '@entities/Product/ui/product-properties/ui'

import { useFormatShelfLife } from '@widgets/product-detail/hooks/useFormatShelfLife'

import { Product, ProductAttribute } from '@shared/generated'
import { cn } from '@shared/lib/cn'

import styles from './About.module.scss'

interface AttributeItemProps {
  attr: ProductAttribute;
}

function AttributeItem (props: AttributeItemProps) {
  const { attr } = props

  return (
    <div className={styles.about__subitem}>
      <h3 className={styles['about__subitem-name']}>{attr?.name}</h3>
      <span className={styles['about__subitem-line']}></span>
      <span className={styles['about__subitem-value']}>{attr?.value}</span>
    </div>
  )
}

interface AboutProductProps {
  product: Product;
}


export default function About (props: AboutProductProps) {
  const shellLife = useFormatShelfLife()
  const { t: tp } = useTranslation('product')

  const { product } = props

  return (
    <div className={styles.about}>
      {product.short_description && (
        <div className={cn(styles.about__item, styles.large)}>
          <h3 className={styles.about__title}>{tp('product.description')}</h3>
          <p className={styles.about__desc}>{product.short_description}</p>
        </div>
      )}

      {product.productProperties && (
        <div className={styles.about__item}>
          <div className={styles.about__nutritionHeader}>
            <h3 className={styles.about__title}>{tp('nutrition.title')}:&nbsp;
              <span className={styles.about__per100g}>{tp('nutrition.per100g')}</span>
              {/* <span className={styles.about__perServing}>{tp('nutrition.perServing')}</span> */}
            </h3>
          </div>
          <div className={styles.about__nutrition}>
            <ProductProperties product={product} />
          </div>
        </div>
      )}

      {product.attributes && !!product.attributes.length && (
        <div className={styles.about__item}>
          <h3 className={styles.about__title}>{tp('product.info')}</h3>
          {product.attributes.map((item) => (
            <AttributeItem attr={item as ProductAttribute} key={item?.name} />
          ))}

          

          {product.brand?.name && (
            <AttributeItem
              attr={{
                name: tp('product.brand'),
                value: product.brand.name,
              } as ProductAttribute}
            />
          )}

          {product.productProperties?.country && (
            <AttributeItem
              attr={{
                name: tp('product.country'),
                value: product.productProperties.country,
              } as ProductAttribute}
            />
          )}

          {product.pkg && (
            <AttributeItem
              attr={{
                name: tp('product.volume'),
                value: product.pkg,
              } as ProductAttribute}
            />
          )}
        </div>
      )}

      {product.productProperties?.shelfLife && (
        <div className={styles.about__item}>
          <h3 className={styles.about__title}>
            {tp('storage.conditions')}
          </h3>
          <AttributeItem
            attr={
              {
                name: tp('storage.maxPeriod'),
                value: shellLife(
                  product.productProperties?.shelfLife as string,
                ),
              } as ProductAttribute
            }
          />

          {product.productProperties?.storageMinTemperature &&
            <AttributeItem
              attr={
                {
                  name: tp('storage.minTemp'),
                  value: `${product.productProperties.storageMinTemperature}°C`,
                } as ProductAttribute
              }
            />
          }

          {product.productProperties?.storageMaxTemperature &&
            <AttributeItem
              attr={
                {
                  name: tp('storage.maxTemp'),
                  value: `${product.productProperties.storageMaxTemperature}°C`,
                } as ProductAttribute
              }
            />
          }
        </div>
      )}
    </div>
  )
}